import { useState } from "react";
import { Helmet } from "react-helmet-async";

const projectData = [
  {
    name: "Reminders App",
    description: "Reminders app for phones",
    link: "#",
    modal: {
      title: "Remiders App for phones",
      details:
        "Building a reminders app for phones, more details coming soon",
    },
  },
  {
    name: "Personal Webpage",
    description: "This very website! Built with React and Node.js.",
    link: "#",
    modal: {
      title: "Personal Webpage",
      details:
        "Built a personal portfolio website with React and Node.js. Includes multi-page navigation, projects showcase, and contact section. Designed with modern UI and responsive layout.",
    },
  },
  {
    name: "Speech Recognition on Microchip",
    description: "Implemented a TensorFlow speech recognition model on a microchip.",
    link: "https://github.com/ljtorrer/speech-recognition",
  },
  {
    name: "Alarm Clock Python Project",
    description: "Built a fully functional alarm clock with Python and Tkinter.",
    link: "https://github.com/ljtorrer/alarm-clock",
  },
];

function Projects() {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeProject, setActiveProject] = useState(null);

  const openModal = (project) => {
    setActiveProject(project);
    setModalOpen(true);
  };

  const closeModal = () => {
    setActiveProject(null);
    setModalOpen(false);
  };

  return (
    <div className="min-h-[calc(100vh-160px)] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-700 flex flex-col items-center px-6 py-16">
      <Helmet>
        <title>My Projects | Luis Torre</title>
        <meta name="description" content="Learn more about Luis Torre, a Computer Engineering graduate working in automation and AI." />
      </Helmet>
      
      <h2 className="text-4xl font-bold text-white mb-4 relative inline-block">Projects
        <span className="absolute left-0 bottom-0 w-full h-1 bg-[#45577a] rounded-full"></span>
      </h2>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
        {projectData.map((project, index) => (
          <div
            key={index}
            onClick={() =>
              project.modal
                ? openModal(project)
                : window.open(project.link, "_blank")
            }
            className="cursor-pointer bg-gray-800 border border-gray-700 rounded-xl p-6 shadow-md hover:shadow-lg hover:scale-[1.02] transition-transform duration-200"
          >
            <h3 className="text-2xl font-semibold text-white mb-2">
              {project.name}
            </h3>
            <p className="text-gray-300">{project.description}</p>
          </div>
        ))}
      </div>

      {/* Modal */}
      {modalOpen && activeProject && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          onClick={closeModal}
        >
          <div
            className="bg-gray-800 p-8 rounded-xl shadow-lg border border-gray-700 max-w-md w-full text-center text-gray-200"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-2xl font-bold text-white mb-4">
              {activeProject.modal.title}
            </h3>
            <p className="mb-6">{activeProject.modal.details}</p>
            <button
              onClick={closeModal}
              className="bg-blue-600 hover:bg-blue-500 px-5 py-2 rounded-lg text-white font-medium transition"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Projects;
